import React, { useContext, useEffect, useState, Suspense } from "react";
import { PeFilterContext } from "../../Contexts/PeFilterContext";
import { TableHeaderContext } from "../../Contexts/TableHeaderContext";
import IndustryFilter from "../../Components/RefineSearchComponents/IndustryFilter";
import SectorFilter from "../../Components/RefineSearchComponents/PESectorFilter";
import StageFilter from "../../Components/RefineSearchComponents/StageFilter";
import RoundFilter from "../../Components/RefineSearchComponents/RoundFilter";
import InvestorTypeFilter from "../../Components/RefineSearchComponents/InvestorTypeFilter";
import InvestorHeadquartersFilter from "../../Components/RefineSearchComponents/InvestorHeadquartersFilter";
import FirmTypeFilter from "../RefineSearchComponents/FirmTypeFilter";
import Switch from "../RefineSearchComponents/AndOrToggleSwtich";
import Tags from "../RefineSearchComponents/Tags";
import InvestorCityTag from '../RefineSearchComponents/InvestorCityTag';
// import InvestorDealFilter from '../RefineSearchComponents/InvestorDealFilter'
import axios from "axios";
import { UserContext } from "../../Contexts/UserContext";
import { filterSectorByIndutry, refineSearchSubFirmTypeUrl, tagList } from "../../Config/config";
import { useLocation, useNavigate } from "react-router-dom";
import { TableDataContext } from "../../Contexts/TableDataContext";
import Constants from "../../Constants";
import { Tooltip } from "antd";
import { FaInfoCircle } from "react-icons/fa";
import DefinitionModal from "../TagDefinitionModal";
import ToggleButton from "../RefineSearchComponents/ToggleAndOrSwitch";
import LAdvisor from '../RefineSearchComponents/lAdvisor';
import TAdvisor from '../RefineSearchComponents/tAdvisor';
import TargetCompany from '../RefineSearchComponents/TargetCompany';
import Investor from "../RefineSearchComponents/Investor";
import InvestorDealRangeFilter from "../RefineSearchComponents/InvestorDealRangeFilter";
import InvestorDealFilter from '../RefineSearchComponents/InvestorDealFilter';
import { IoMdArrowDropdown, IoMdArrowDropright } from "react-icons/io";
import FirmTypeSubMenu from "../RefineSearchComponents/FirmTypeSubMenu";

/**
 * The InvestorRefineSearch function is a React component that renders a form for refining search
 * filters .
 * @returns The function `InvestorRefineSearch` returns a JSX element.
 */
export default function InvestorRefineSearch({ customPathname, generalPathname, menu }) {
    const {
        onErrorHandler, dropdown, isMobile, setOpen, open, setrefineSearchFilters, dbDropdown, setSubFirmType, setDbDropdown, Sectors, setSectors, HeadquarterCityOptions, setHeadquarterCityOptions, setMonthPickerValue, refineSearchFilters, setSelectedInvestorHeadquartersCity, selectedInvestorHeadquartersCity, SwitchState, InvestorOptions, setInvestorOptions,
        lAdvisorsOptions, setlAdvisorsOptions, tAdvisorsOptions, settAdvisorsOptions, TargetCompanyOptions, setTargetCompanyOptions, getSectorByIndustry, accessControl } = useContext(PeFilterContext);
    const { setCurrentPage } = useContext(TableDataContext);
    const [select, setSelected] = useState(32);
    const { getToken } = useContext(UserContext);
    const location = useLocation()
    const navigate = useNavigate();
    const { pathname } = useLocation()
    const isFromGlobalSearch = () => refineSearchFilters[pathname]?.globalSearch?.length > 0 ? true : false
    const isFromSearchedList = () => refineSearchFilters[location?.state?.prevPath]?.globalSearch?.length > 0 ? true : false

    console.log(selectedInvestorHeadquartersCity, "bhkb")

    //local updated options
    const [IndustriesOptions, setIndustriesOptions] = useState([])
    const [SectorOptions, setSectorOptions] = useState([])
    const [StageOptions, setStageOptions] = useState([])
    const [RoundOptions, setRoundOptions] = useState([])
    const [InvestorTypeOptions, setInvestorTypeOptions] = useState([])
    const [HeadquartersOptions, setHeadquartersOptions] = useState([])
    const [FirmTypeOptions, setFirmTypeOptions] = useState([])
    const [FirmSubTypeOptions, setFirmSubTypeOptions] = useState([])
    const [DealRange, setDealRange] = useState({ from: "", to: "" })
    const [invDealRange, setInvDealRange] = useState({ from: "", to: "" })
    const [TagSwitchState, setSwitchState] = useState(true)
    const [TagsOptions, setTagsOptions] = useState([])
    const [CityOptions, setCityOptions] = useState([])
    const [MinDealOptions, setMinDealOptions] = useState([])
    const [MaxDealOptions, setMaxDealOptions] = useState([])

    // State for managing which filter section is active
    const [activeFilterSection, setActiveFilterSection] = useState("keyword");

    // State for managing which individual filter popup is open
    const [openFilterPopup, setOpenFilterPopup] = useState(null);
    // setSelectedInvestorHeadquartersCity(HeadquarterCityOptions?.filter(option => option.isChecked))
    // setSelectedInvestorHeadquartersCity(HeadquarterCityOptions?.filter(option => option.isChecked))
    // console.log(HeadquarterCityOptions?.filter(option => option.isChecked) ,"ljhkjh" )

    // Helper functions to count applied filters for each section
    const getDealFiltersCount = () => {
        let count = 0;
        if (StageOptions?.some(option => option.isChecked)) count++;
        if (RoundOptions?.some(option => option.isChecked)) count++;
        if (DealRange?.from || DealRange?.to) count++;
        if (invDealRange?.from || invDealRange?.to) count++;
        return count;
    };

    const getCompanyFiltersCount = () => {
        let count = 0;
        if (IndustriesOptions?.some(option => option.isChecked)) count++;
        if (SectorOptions?.some(option => option.isChecked)) count++;
        return count;
    };

    const getInvestorFiltersCount = () => {
        let count = 0;
        if (InvestorTypeOptions?.some(option => option.isChecked)) count++;
        if (HeadquartersOptions?.some(option => option.isChecked)) count++;
        if (HeadquarterCityOptions?.some(option => option.isChecked)) count++;
        if (FirmTypeOptions?.some(option => option.isChecked)) count++;
        if (CityOptions?.some(option => option.isChecked)) count++;
        return count;
    };

    const getKeywordFiltersCount = () => {
        let count = 0;
        if (TagsOptions.length > 0) count++;
        if (InvestorOptions?.some(option => option.isChecked)) count++;
        if (TargetCompanyOptions?.some(option => option.isChecked)) count++;
        if (lAdvisorsOptions?.some(option => option.isChecked)) count++;
        if (tAdvisorsOptions?.some(option => option.isChecked)) count++;
        return count;
    };

    const applyFilter = () => {
        const selectedIndustries = IndustriesOptions.filter(industry => industry.isChecked);
        const selectedSectors = SectorOptions.filter(option => option.isChecked);
        const selectedStages = StageOptions.filter(option => option.isChecked);
        const selectedRounds = RoundOptions.filter(option => option.isChecked);
        console.log(selectedRounds, 'rounds')
        const selectedCity = CityOptions?.filter(option => option.isChecked);
        const selectedInvestorType = InvestorTypeOptions?.filter(option => option.isChecked);
        const selectedHeadCity = HeadquarterCityOptions?.filter(option => option.isChecked);
        const selectedHead = HeadquartersOptions?.filter(option => option.isChecked);
        const selectedHeadNames = selectedHeadCity.map(option => option.name);
        const selectedFirm = FirmTypeOptions?.filter(option => option.isChecked);
        const selectedFirmSubTypes = FirmSubTypeOptions?.filter(option => option.isChecked);
        setSelectedInvestorHeadquartersCity(HeadquarterCityOptions?.filter(option => option.isChecked))
        const selectedOperators = SwitchState;
        const selectedlAdvisors = lAdvisorsOptions?.filter(option => option.isChecked);
        const selectedtAdvisors = tAdvisorsOptions?.filter(option => option.isChecked);
        const selectedTargetCompany = TargetCompanyOptions?.filter(option => option.isChecked);
        const selectedInvestor = InvestorOptions?.filter(option => option.isChecked);

        console.log(selectedHeadCity, "bhkb", selectedHead)
        const firmTypeNames = selectedFirm?.filter(firm => firm.isChecked).map(firm => firm.name) ?? [];
        let filteredFirmSubTypes = null;

        const excludedNames = ['Healthcare(PE)', 'Cleantech(PE)', 'Healthcare(VC)', 'Cleantech(VC)'];

        if (firmTypeNames.includes('PE') || firmTypeNames.includes('VC')) {
            filteredFirmSubTypes = selectedFirmSubTypes?.filter(sub => {
                const isPE = sub.name?.includes('(PE)') || sub.originalName?.includes('(PE)');
                const isVC = sub.name?.includes('(VC)') || sub.originalName?.includes('(VC)');

                if (firmTypeNames.includes('PE') && firmTypeNames.includes('VC')) {
                    return isPE || isVC;
                } else if (firmTypeNames.includes('PE')) {
                    return isPE;
                } else if (firmTypeNames.includes('VC')) {
                    return isVC;
                }
                return false;
            })?.map(sub => {
                if (!excludedNames.includes(sub.name)) {
                    return {
                        ...sub,
                        name: sub.name.replace(/\((PE|VC)\)/, ''),
                    };
                }
                return sub;
            }) ?? null;

            if (filteredFirmSubTypes.length === 0) {
                filteredFirmSubTypes = null;
            }
        }

        const invMin = MinDealOptions?.filter(option => option.isChecked)?.at(0) ?? null;
        const invMax = MaxDealOptions?.filter(option => option.isChecked)?.at(0) ?? null;
        setrefineSearchFilters(prev => ({
            ...prev,
            [generalPathname]: {
                ...prev[generalPathname],
                industry: selectedIndustries,
                sector: selectedSectors,
                city: selectedCity,
                investorType: selectedInvestorType,
                investorHeadquarters: selectedHead,
                investor_city: selectedHeadCity,
                firmType: selectedFirm,
                firm_Sub_type: filteredFirmSubTypes,
                operator: TagSwitchState ? 1 : 0,
                tags: TagsOptions,
                deals_operator: selectedOperators,
                ladvisors: selectedlAdvisors,
                tadvisors: selectedtAdvisors,
                investor_id: selectedInvestor,
                target_company: selectedTargetCompany,
            },
            [customPathname]: {
                ...prev[customPathname],
                stage: selectedStages,
                round: selectedRounds,
                dealRange: DealRange?.from != "" && DealRange?.to != "" ? [{ id: 0, name: DealRange?.from }, { id: 1, name: DealRange?.to }] : [],
                dealInvestorRange: invDealRange?.from != "" && invDealRange?.to != "" ? [{ id: 0, name: invDealRange?.from }, { id: 1, name: invDealRange?.to }] : []
            },
        }))
        console.log(refineSearchFilters, "khk", selectedHeadCity)
    }

    const resetFilter = () => {

        setrefineSearchFilters(prev => ({
            ...prev,
            [generalPathname]: {},
            [customPathname]: {}
        }))
        setHeadquarterCityOptions(HeadquarterCityOptions.map(option => {
            if (option.isChecked) {
                return { ...option, isChecked: false };
            }
            return option;
        }));
        setlAdvisorsOptions([]);
        settAdvisorsOptions([]);
        setTargetCompanyOptions([]);
        setInvestorOptions([]);
        setSectors([]);

        console.log(refineSearchFilters, "hkjh")
    }


    // Submitting Refine Search Form 
    const refineSearchFilter = (event) => {
        if (isMobile) {
            setOpen(!open);
        }
        setrefineSearchFilters(prev => ({
            ...prev,
            [generalPathname]: {
                ...prev[generalPathname],
            },
            [customPathname]: {
                globalSearch: [],
            }
        }))
        if (isFromGlobalSearch() || isFromSearchedList()) {
            setMonthPickerValue(Constants.initialMonthRange)
        }
        event.preventDefault();
        setCurrentPage(1);
        applyFilter();
        setSelected(false)
        if (location.pathname != customPathname) {
            navigate(customPathname)
        }

    }

    const onResetClick = (event) => {
        event.preventDefault();
        setCurrentPage(1);
        resetFilter()
        if (location.pathname != customPathname) {
            navigate(customPathname)
        }
    }

    const accordionClick = (val) => {
        if (val === select) {
            setSelected(0);
        } else {
            setSelected(val);
        }
    };

    useEffect(() => {
        const ids = IndustriesOptions?.length > 0 ?
            IndustriesOptions.filter(industry => industry.isChecked)?.map(option => option.id) : [];

        if (ids?.length > 0) {
            getSectorByIndustry(ids, "investments")
        } else {
            setSectors([])
        }

    }, [IndustriesOptions])

    useEffect(() => {
        if (accessControl?.peindustries?.id?.length > 0) {
            const ids = accessControl ? accessControl?.peindustries?.id : []
            getSectorByIndustry(ids, "investments")
        }
    }, [])

    // useEffect(() => {
    //     const ids = FirmTypeOptions?.filter(industry => industry.isChecked)?.map(option => option.id);

    //     if (ids?.length > 0) {
    //         let firmType = "All";
    //         if (ids.length === 1) {
    //             if (ids[0] === 1) firmType = "PE";
    //             else if (ids[0] === 2) firmType = "VC";
    //         }

    //         axios.post(refineSearchSubFirmTypeUrl, {
    //             firm_type: firmType,
    //         }, {
    //             headers: {
    //                 "Authorization": getToken()
    //             }
    //         }).then(response => {
    //             if (response.status === 200) {
    //                 setSubFirmType(response.data?.firmType ?? []);
    //             } else {
    //                 setSubFirmType([]);
    //             }
    //         }).catch(onErrorHandler);
    //     } else {
    //         setSubFirmType([]);
    //     }
    // }, [FirmTypeOptions]);

    const getSearchTags = async (searchText, type) => {
        try {
            const response = await axios.post(tagList, {
                "tag": searchText,
                "type": type,
                "includes_secondary_tags": secondaryTagCheck

            }, {
                headers: {
                    "Authorization": getToken()
                }
            });

            if (response.status === 200) {
                return response.data;
            } else {
                return [];
            }
        } catch (error) {
            return [];
        }
    }


    const fetchData = async () => {
        const tags = await getSearchTags("ALL", "noncompetitor");
        const competitorTags = await getSearchTags("ALL", "competitor")
        const secondaryTags = await getSearchTags("ALL", "secondary")
        // console.log(tags, competitorTags, 'promi')
        openTagModal(tags, competitorTags, secondaryTags)
    };
    
    const [showDefinitionModal, setShowDefinitionModal] = useState(false);
    const [defValues, setDefValues] = useState({})
    const [secondaryTagCheck, setSecondaryTagCheck] = useState(true);
    console.log(defValues, 'showValues');

    const openTagModal = (non_comp, comp, s_tags) => {
        setShowDefinitionModal(true);
        setDefValues({
            non_comp: non_comp,
            comp: comp,
            s_tags: s_tags
        })
    }

    const defCloseHandler = () => {
        setShowDefinitionModal(false);
        setDefValues({})
    }

    const toggleSwitchState = () => {
        setSwitchState(prevState => prevState === "and" ? "or" : "and");
    };
    const handleDbToggle = () => {
        setDbDropdown(!dbDropdown);
    };

    const getPeVcSelectedTypes = () => {
        return FirmTypeOptions?.filter(option =>
            (option.id === 1 || option.id === 2) && option.isChecked
        ) || [];
    };

    return (
        <div className="bg-white">
            <div className="h-full no-scrollbar">
                <form onSubmit={refineSearchFilter} onReset={onResetClick} className="h-full w-full">
                    <main className="h-full w-full py-4">
                        <div className="flex flex-col md:grid md:grid-cols-8 gap-2 md:gap-4 h-full">
                            {/* Left column - Headers (30%) */}
                            <div className="flex flex-row md:flex-col gap-1 md:gap-2 border-b md:border-b-0 md:border-r border-gray-300 pb-2 md:pb-0 md:pr-4 md:max-w-[320px] md:col-span-2 items-baseline md:items-stretch overflow-x-auto flex-wrap md:flex-nowrap">
                                <div
                                    className={`cursor-pointer p-2 md:p-3 rounded-lg transition-colors w-auto md:w-full flex items-center justify-between ${activeFilterSection === 'keyword' ? 'bg-[#BC8B20] text-white' : 'hover:bg-gray-100'
                                        }`}
                                    onClick={() => setActiveFilterSection(activeFilterSection === 'keyword' ? null : 'keyword')}
                                >
                                    <div className="flex items-center gap-1 md:gap-2">
                                        <span className="text-xs md:text-base font-medium">Keyword Search</span>
                                        {getKeywordFiltersCount() > 0 && (
                                            <span className={`text-xs rounded-full px-1 md:px-2 py-0.5 md:py-1 min-w-[18px] md:min-w-[20px] h-5 inline-flex items-center justify-center ${activeFilterSection === 'keyword'
                                                    ? 'bg-white text-[#bc8b20]'
                                                    : 'bg-[#bc8b20] text-white'
                                                }`}>
                                                {getKeywordFiltersCount()}
                                            </span>
                                        )}
                                    </div>
                                    {activeFilterSection === 'keyword' ? <IoMdArrowDropdown /> : <IoMdArrowDropright />}
                                </div>
                                <div
                                    className={`cursor-pointer p-2 md:p-3 rounded-lg transition-colors w-auto md:w-full flex items-center justify-between ${activeFilterSection === 'deal' ? 'bg-[#BC8B20] text-white' : 'hover:bg-gray-100'
                                        }`}
                                    onClick={() => setActiveFilterSection(activeFilterSection === 'deal' ? null : 'deal')}
                                >
                                    <div className="flex items-center gap-1 md:gap-2">
                                        <span className="text-xs md:text-base font-medium">Deal</span>
                                        {getDealFiltersCount() > 0 && (
                                            <span className={`text-xs rounded-full px-1 md:px-2 py-0.5 md:py-1 min-w-[18px] md:min-w-[20px] h-5 inline-flex items-center justify-center ${activeFilterSection === 'deal'
                                                    ? 'bg-white text-[#bc8b20]'
                                                    : 'bg-[#bc8b20] text-white'
                                                }`}>
                                                {getDealFiltersCount()}
                                            </span>
                                        )}
                                    </div>
                                    {activeFilterSection === 'deal' ? <IoMdArrowDropdown /> : <IoMdArrowDropright />}
                                </div>
                                <div
                                    className={`cursor-pointer p-2 md:p-3 rounded-lg transition-colors w-auto md:w-full flex items-center justify-between ${activeFilterSection === 'company' ? 'bg-[#BC8B20] text-white' : 'hover:bg-gray-100'
                                        }`}
                                    onClick={() => setActiveFilterSection(activeFilterSection === 'company' ? null : 'company')}
                                >
                                    <div className="flex items-center gap-1 md:gap-2">
                                        <span className="text-xs md:text-base font-medium">Company</span>
                                        {getCompanyFiltersCount() > 0 && (
                                            <span className={`text-xs rounded-full px-1 md:px-2 py-0.5 md:py-1 min-w-[18px] md:min-w-[20px] h-5 inline-flex items-center justify-center ${activeFilterSection === 'company'
                                                    ? 'bg-white text-[#bc8b20]'
                                                    : 'bg-[#bc8b20] text-white'
                                                }`}>
                                                {getCompanyFiltersCount()}
                                            </span>
                                        )}
                                    </div>
                                    {activeFilterSection === 'company' ? <IoMdArrowDropdown /> : <IoMdArrowDropright />}
                                </div>
                                <div
                                    className={`cursor-pointer p-2 md:p-3 rounded-lg transition-colors w-auto md:w-full flex items-center justify-between ${activeFilterSection === 'investor' ? 'bg-[#BC8B20] text-white' : 'hover:bg-gray-100'
                                        }`}
                                    onClick={() => setActiveFilterSection(activeFilterSection === 'investor' ? null : 'investor')}
                                >
                                    <div className="flex items-center gap-1 md:gap-2">
                                        <span className="text-xs md:text-base font-medium">Investor</span>
                                        {getInvestorFiltersCount() > 0 && (
                                            <span className={`text-xs rounded-full px-1 md:px-2 py-0.5 md:py-1 min-w-[18px] md:min-w-[20px] h-5 inline-flex items-center justify-center ${activeFilterSection === 'investor'
                                                    ? 'bg-white text-[#bc8b20]'
                                                    : 'bg-[#bc8b20] text-white'
                                                }`}>
                                                {getInvestorFiltersCount()}
                                            </span>
                                        )}
                                    </div>
                                    {activeFilterSection === 'investor' ? <IoMdArrowDropdown /> : <IoMdArrowDropright />}
                                </div>
                            </div>

                            {/* Right column - Filters */}
                            <div className="overflow-visible md:overflow-auto mt-4 md:mt-0 max-h-[calc(100vh-300px)] md:max-h-none pb-20 md:pb-0 md:col-span-6">
                                <div className={`w-full md:w-1/2 ${activeFilterSection === 'keyword' ? '' : 'hidden'} relative`}>
                                    <div className="space-y-4">
                                        <div className="flex items-center gap-4 border border-gray-300 rounded-md p-1 md:gap-0">
                                            <div className="p-0 m-0 bg-white input-search relative flex items-center w-full">
                                                <Tags
                                                    TagsOptions={TagsOptions}
                                                    customPathname={generalPathname}
                                                    setTagsOptions={setTagsOptions}
                                                    getSearchTags={getSearchTags}
                                                    SwitchState={TagSwitchState}
                                                    setSwitchState={setSwitchState}
                                                />
                                                <Switch
                                                    SwitchState={TagSwitchState}
                                                    setSwitchState={setSwitchState}
                                                    customPathname={generalPathname}
                                                />
                                            </div>
                                            <div className="md:hidden flex items-center">
                                                <Tooltip title='Tag List'>
                                                    <FaInfoCircle
                                                        size={16}
                                                        color="grey"
                                                        className="cursor-pointer px-[1px]"
                                                        onClick={fetchData}
                                                    />
                                                </Tooltip>
                                            </div>
                                        </div>
                                        <div style={{ marginTop: "0.5rem" }} className="mt-2 cursor-pointer flex justify-end items-center text-xs gap-1">
                                            <input type="checkbox" checked={secondaryTagCheck} onChange={() => setSecondaryTagCheck(!secondaryTagCheck)} title="includes secondary tags" />
                                            <span>include secondary tags</span>
                                        </div>
                                        <Tooltip title='Tag List'>
                                            <FaInfoCircle
                                                size={16}
                                                color="grey"
                                                className="cursor-pointer hidden md:block absolute md:left-[103%] md:top-0"
                                                onClick={fetchData}
                                            />
                                        </Tooltip>
                                    </div>
                                    <div className="mt-4 space-y-4">
                                        <Investor
                                            options={InvestorOptions}
                                            setOptions={setInvestorOptions}
                                            customPathname={generalPathname}
                                            accordionClick={() => accordionClick(32)}
                                            label="Investor"
                                            open={select === 32}
                                            menu={menu}
                                        />
                                        <TargetCompany
                                            options={TargetCompanyOptions}
                                            setOptions={setTargetCompanyOptions}
                                            customPathname={generalPathname}
                                            accordionClick={() => accordionClick(31)}
                                            label="Target Company"
                                            open={select === 31}
                                            menu={menu}
                                        />
                                        <LAdvisor
                                            options={lAdvisorsOptions}
                                            setOptions={setlAdvisorsOptions}
                                            customPathname={generalPathname}
                                            label="Legal Advisors"
                                            accordionClick={() => accordionClick(21)}
                                            open={select === 21}
                                            menu={menu}
                                        />
                                        <TAdvisor
                                            options={tAdvisorsOptions}
                                            setOptions={settAdvisorsOptions}
                                            label="Transaction Advisors"
                                            customPathname={generalPathname}
                                            accordionClick={() => accordionClick(29)}
                                            open={select === 29}
                                            menu={menu}
                                        />
                                    </div>
                                </div>

                                <div className={`grid grid-cols-1 sm:grid-cols-2 gap-4 gap-y-4 md:grid-cols-2 md:gap-4 md:gap-y-8 ${activeFilterSection === 'deal' ? '' : 'hidden'}`}>
                                    <StageFilter
                                        StageOptions={StageOptions}
                                        customPathname={customPathname}
                                        setStageOptions={setStageOptions}
                                        accordionClick={() => accordionClick(3)}
                                        open={select === 3}
                                        menu={menu}
                                        isPopupOpen={openFilterPopup === 'stage'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'stage' : null)}
                                    />
                                    <RoundFilter
                                        RoundOptions={RoundOptions}
                                        setRoundOptions={setRoundOptions}
                                        customPathname={customPathname}
                                        accordionClick={() => accordionClick(4)}
                                        open={select === 4}
                                        menu={menu}
                                        isPopupOpen={openFilterPopup === 'round'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'round' : null)}
                                    />
                                    <InvestorDealRangeFilter
                                        DealRange={DealRange}
                                        setDealRange={setDealRange}
                                        customPathname={customPathname}
                                        isPopupOpen={openFilterPopup === 'dealRange'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'dealRange' : null)}
                                    />
                                    <InvestorDealFilter
                                        customPathname={customPathname}
                                        invDealRange={invDealRange}
                                        setInvDealRange={setInvDealRange}
                                        isPopupOpen={openFilterPopup === 'investorDealRange'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'investorDealRange' : null)}
                                    />
                                </div>

                                <div className={`grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-4 md:grid-cols-2 md:gap-x-6 md:gap-y-8 ${activeFilterSection === 'company' ? '' : 'hidden'}`}>
                                    <IndustryFilter
                                        IndustriesOptions={IndustriesOptions}
                                        setIndustriesOptions={setIndustriesOptions}
                                        customPathname={generalPathname}
                                        accordionClick={() => accordionClick(1)}
                                        open={select === 1}
                                        isPopupOpen={openFilterPopup === 'industry'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'industry' : null)}
                                    />
                                    <SectorFilter
                                        SectorOptions={SectorOptions}
                                        setSectorOptions={setSectorOptions}
                                        accordionClick={() => accordionClick(2)}
                                        customPathname={generalPathname}
                                        open={select === 2}
                                        isPopupOpen={openFilterPopup === 'sector'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'sector' : null)}
                                    />
                                    <InvestorCityTag
                                        CityOptions={CityOptions}
                                        setCityOptions={setCityOptions}
                                        customPathname={generalPathname}
                                        isPopupOpen={openFilterPopup === 'investorCity'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'investorCity' : null)}
                                    />
                                </div>

                                <div className={`grid grid-cols-1 sm:grid-cols-2 gap-4 gap-y-4 md:grid-cols-2 md:gap-4 md:gap-y-6 ${activeFilterSection === 'investor' ? '' : 'hidden'}`}>
                                    <InvestorTypeFilter
                                        InvestorTypeOptions={InvestorTypeOptions}
                                        setInvestorTypeOptions={setInvestorTypeOptions}
                                        customPathname={generalPathname}
                                        isPopupOpen={openFilterPopup === 'investorType'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'investorType' : null)}
                                    />
                                    <InvestorHeadquartersFilter
                                        HeadquartersOptions={HeadquartersOptions}
                                        setHeadquartersOptions={setHeadquartersOptions}
                                        customPathname={generalPathname}
                                        setHeadquarterCityOptions={setHeadquarterCityOptions}
                                        HeadquarterCityOptions={HeadquarterCityOptions}
                                        isPopupOpen={openFilterPopup === 'investorHeadquarters'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'investorHeadquarters' : null)}
                                    />
                                    <FirmTypeFilter
                                        FirmTypeOptions={FirmTypeOptions}
                                        setFirmTypeOptions={setFirmTypeOptions}
                                        FirmSubTypeOptions={FirmSubTypeOptions}
                                        setFirmSubTypeOptions={setFirmSubTypeOptions}
                                        customPathname={generalPathname}
                                        dataPath="investments"
                                        isPopupOpen={openFilterPopup === 'firmType'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'firmType' : null)}
                                    />
                                </div>

                                <div className={`flex items-center justify-center h-40 text-gray-500 ${!activeFilterSection ? '' : 'hidden'}`}>
                                    <p>Select a filter category from the left to view available filters</p>
                                </div>
                            </div>
                        </div>
                    </main>
                </form>
            </div>
            {showDefinitionModal && 
                <DefinitionModal 
                    values={defValues} 
                    onClose={defCloseHandler} 
                    TagsOptions={TagsOptions} 
                    setTagsOptions={setTagsOptions}
                    customPathname={generalPathname}
                />}
        </div>
    );
}
